import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { SharedModule } from '../shared/shared.module';

import { LayoutComponent } from './layout.component';
import { HeaderComponent } from './header/header.component';
import { ModalComponent } from '../modal/modal.component';
import { NotificationBarComponent } from '../notification-bar/notification-bar.component';
import { FooterComponent } from './footer/footer.component';


@NgModule({
    imports: [
        CommonModule,
        SharedModule,
        RouterModule
    ],
    declarations: [
        LayoutComponent,
        HeaderComponent,
        ModalComponent,
        NotificationBarComponent,
        FooterComponent
    ],
    exports: [
        LayoutComponent
    ]
})
export class LayoutModule { }
